// User

import * as helper from './helpers';

const cssPrefix = helper.getCSSVariable('--prefix');


// Sales chart
const salesChart = document.getElementById('salesChart');

if(salesChart) {
    import(/* webpackChunkName: 'chart.js' */ './vendors/chart')
    .then(() => {
        new Chart(salesChart, {
            // The type of chart we want to create
            type: 'bar',
        
            // The data for our dataset
            data: {
                labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                datasets: [
                    {
                        label: 'Projections',
                        data: [12440, 15021, 10081, 10984, 8409, 12532, 13986, 19227, 12636, 10171, 6753, 15589],
                        backgroundColor: helper.getCSSVariable(`${cssPrefix}primary`)
                    },
                    {
                        label: 'Actual',
                        data: [12357, 13665, 9071, 9914, 5115, 12291, 10010, 19092, 11976, 9174, 5189, 14523],
                        backgroundColor: helper.getCSSVariable(`${cssPrefix}light`),
                        borderRadius: 30
                    }
                ]
            },
        
            // Configuration options
            options: {
                scales: {
                    x: {
                        stacked: true,
                        gridLines: {
                            display: false
                        }
                    },
                    y: {
                        stacked: true,
                        ticks: {
                            callback: (value, index, values) => {
                                return value > 0 ? '$' + Math.floor(value / 1000) + 'k' : value;
                            }
                        }
                    }
                },
                plugins: {
                    tooltip: {
                        callbacks: {
                            label: context => {
                                return new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(context.parsed.y);
                            },
                            labelColor: context => {
                                return {
                                    backgroundColor: context.dataset.backgroundColor
                                };
                            }
                        }
                    }
                }
                
            }
        });
    })
    .catch(console.warn);
}
  

// Income chart
const incomeChart = document.getElementById('incomeChart');
       
if(incomeChart) {
    import(/* webpackChunkName: 'chart.js' */ './vendors/chart')
    .then(() => {
        new Chart(incomeChart, {
            // The type of chart we want to create
            type: 'line',

            // The data for our dataset
            data: {
                labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                datasets: [
                    {
                        backgroundColor: (context) => {
                            const chart = context.chart;
                            const {ctx, chartArea} = chart;
                    
                            if (!chartArea) {
                                return null;
                            }
                            return helper.getGradient(
                                ctx,
                                chartArea,
                                `rgba(${helper.getCSSVariable(`${cssPrefix}primary-rgb`)}, 0.5)`,
                                `rgba(${helper.getCSSVariable(`${cssPrefix}primary-rgb`)}, 0.2)`,
                                `rgba(${helper.getCSSVariable(`${cssPrefix}primary-rgb`)}, 0)`
                            );
                        },
                        data: [400, 1000, 1000, 2500, 3000, 1500, 4000, 5000, 8000, 6000, 5500, 6500]
                    }
                ]
            },

            // Configuration options
            options: {
                layout: {
                    padding: {
                        top: 2,
                        bottom: -10
                    }
                },
                scales: {
                    x: {
                        ticks: {
                            display: false
                        },
                        grid: {
                            drawOnChartArea: true
                        }
                    },
                    y: {
                        display: false
                    }
                },
                plugins: {
                    tooltip: {
                        callbacks: {
                            label: (context) => {
                                return new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(context.parsed.y);
                            }
                        }
                    }
                }
            }
        });
    })
    .catch(console.warn);
}


// Pageviews chart
const pageViewsChart = document.getElementById('pageViewsChart');

if(pageViewsChart) {
    import(/* webpackChunkName: 'chart.js' */ './vendors/chart')
    .then(() => {
        new Chart(pageViewsChart, {
            // The type of chart we want to create
            type: 'bar',
        
            // The data for our dataset
            data: {
                labels: ['1 May, 2022', '5 May, 2022', '10 May, 2022', '15 May, 2022', '20 May, 2022', '25 May, 2022', '30 May, 2022'],
                datasets: [
                    {
                        label: 'Projections',
                        data: [17, 20, 24, 34, 12, 10, 8],
                        backgroundColor: helper.getCSSVariable(`${cssPrefix}light`),
                        borderRadius: 30
                    }
                ]
            },
        
            // Configuration options
            options: {
                hoverBackgroundColor: helper.getCSSVariable(`${cssPrefix}primary`),
                barThickness: 7,
                scales: {
                    x: {
                        display: false
                    },
                    y: {
                        display: false
                    }
                },
                plugins: {
                    tooltip: {  
                        callbacks: {
                            label: (context) => {
                                return context.parsed.y + '%';
                            },
                            labelColor: (context) => {
                                return {
                                    backgroundColor: helper.getCSSVariable(`${cssPrefix}primary`)
                                };
                            }
                        }
                    }
                }
                
            }
        });
    })
    .catch(console.warn);
}


// Order status chart
const orderStatusChart = document.getElementById('orderStatusChart');
        
if(orderStatusChart){
    import(/* webpackChunkName: 'chart.js' */ './vendors/chart')
    .then(() => {
        new Chart(orderStatusChart, {
            // The type of chart we want to create
            type: 'roundedDoughnut',
        
            // The data for our dataset
            data: {
                labels: [
                    'Delivered',
                    'In progress',
                    'To-do'
                ],
                datasets: [
                    {
                        label: 'Order status',
                        data: [29, 45, 26],
                        backgroundColor: [
                            helper.getCSSVariable(`${cssPrefix}primary`),
                            helper.getCSSVariable(`${cssPrefix}dark`),
                            helper.getCSSVariable(`${cssPrefix}gray-300`)
                        ]
                    }
                ]
            },

            // Configuration options
            options: {
                plugins: {
                    tooltip: {  
                        callbacks: {
                            label: (context) => {
                                return context.parsed + '%';
                            }
                        }
                    }
                }
            }
        });
    })
    .catch(console.warn);
}


// Sales report chart
const salesReportChart = document.getElementById('salesReportChart');

if(salesReportChart) {
    import(/* webpackChunkName: 'chart.js' */ './vendors/chart')
    .then(() => {
        new Chart(salesReportChart, {
            // The type of chart we want to create
            type: 'line',

            // The data for our dataset
            data: {
                labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                datasets: [
                    {
                        label: 'Income',
                        data: [28, 70, 68, 77, 35, 24, 18, 73, 29, 43, 19, 24],
                        borderWidth: 4,
                        borderColor: helper.getCSSVariable(`${cssPrefix}primary`)
                    },
                    {
                        label: 'Expense',
                        data: [18, 23, 79, 37, 19, 45, 55, 72, 79, 57, 32, 59],
                        borderWidth: 4,
                        borderColor: helper.getCSSVariable(`${cssPrefix}dark`),
                        hidden: true
                    }
                ]
            },

            // Configuration options
            options: {
                scales: {
                    y: {
                        ticks: {
                            callback: (value, index, values) => {
                                return value > 0 ? '$' + value + 'k' : value;
                            }
                        }
                    }
                },
                plugins: {
                    tooltip: {
                        callbacks: {
                            label: (context) => {
                                return new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(context.parsed.y);
                            }
                        }
                    }
                }
            }
        });
    })
    .catch(console.warn);
}


// Current balance chart
const currentBalanceChart = document.getElementById('currentBalanceChart');

if(currentBalanceChart) {
    import(/* webpackChunkName: 'chart.js' */ './vendors/chart')
    .then(() => {
        new Chart(currentBalanceChart, {
            // The type of chart we want to create
            type: 'line',

            // The data for our dataset
            data: {
                labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                datasets: [
                    {
                        backgroundColor: (context) => {
                            const chart = context.chart;
                            const {ctx, chartArea} = chart;
                    
                            if (!chartArea) {
                                return null;
                            }
                            return helper.getGradient(
                                ctx,
                                chartArea,
                                `rgba(${helper.getCSSVariable(`${cssPrefix}white-rgb`)}, 0.6)`,
                                `rgba(${helper.getCSSVariable(`${cssPrefix}white-rgb`)}, 0.3)`,
                                `rgba(${helper.getCSSVariable(`${cssPrefix}white-rgb`)}, 0)`
                            );
                        },
                        borderWidth: 3,
                        borderColor: helper.getCSSVariable(`${cssPrefix}white`),
                        data: [400, 1000, 1000, 2500, 3000, 1500, 4000, 5000, 8000, 6000, 5500, 6500]
                    }
                ]
            },

            // Configuration options
            options: {
                layout: {
                    padding: {
                        top: 2,
                        bottom: -10
                    }
                },
                scales: {
                    x: {
                        ticks: {
                            display: false
                        }
                    },
                    y: {
                        display: false
                    }
                },
                plugins: {
                    tooltip: {
                        callbacks: {
                            label: (context) => {
                                return new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(context.parsed.y);
                            },
                            labelColor: (context) => {
                                return {
                                    backgroundColor: helper.getCSSVariable(`${cssPrefix}light`)
                                };
                            }
                        }
                    }
                }
            }
        });
    })
    .catch(console.warn);
}


// Profile completion chart
const profileCompletionChart = document.getElementById('profileCompletionChart');

if(profileCompletionChart) {
    import(/* webpackChunkName: 'chart.js' */ './vendors/chart')
    .then(() => {
        new Chart(profileCompletionChart, {
            // The type of chart we want to create
            type: 'roundedDoughnut',
        
            // The data for our dataset
            data: {
                labels: [
                    'Completed',
                    'Not completed'
                ],
                datasets: [
                    {
                        data: [75, 25],
                        backgroundColor: [
                            helper.getCSSVariable(`${cssPrefix}primary`),
                            helper.getCSSVariable(`${cssPrefix}light`)
                        ]
                    }
                ]
            },

            // Configuration options
            options: {
                plugins: {
                    tooltip: {  
                        callbacks: {
                            label: (context) => {
                                return context.parsed + '%';
                            }
                        }
                    }
                }
            }
        });
    })
    .catch(console.warn);
}


// World map
const worldMap = document.getElementById('worldMap');

if(worldMap) {
    import(/* webpackChunkName: 'jsvectormap' */ './vendors/jsvectormap')
    .then(({mapDefaultOptions}) => {
        // The data for our dataset
        const worldMapMarkers = [
            {
                coords: [-33.8481643, 150.7915504],
                name: 'Sydney',
                description: 'Hello this is Sydney'
            },
            {
                coords: [40.7127837, -74.0059413],
                name: 'New York',
                description: 'Welcom from Sydney'
            },
            {
                coords: [34.052235, -118.243683],
                name: 'Los Angeles',
                description: 'Hurray LA!'
            },
            {
                coords: [51.507351, -0.127758],
                name: 'London'
            },
            {
                coords: [19.0822375, 72.8109751],
                name: 'Mumbai'
            }
        ];
        
        // Configuration options
        const mapUserOptions = {
            selector: worldMap,
            markers: worldMapMarkers,
            onMarkerTooltipShow(event, tooltip, index) {
                tooltip.getElement().innerHTML = `${tooltip.text()}<br/>${
                    worldMapMarkers[index].description || ''
                }`;
            }
        }
        
        // Merge map options
        const options = {
            ...mapDefaultOptions,
            ...mapUserOptions
        };
    
        const map = new jsVectorMap(options);
    })
    .catch(console.warn);
}

// Profile completion chart
const hbgCompletionChart = document.getElementById('hbgCompletionChart');
if (hbgCompletionChart) {
  __webpack_require__.e(/*! import() | chart.js */ "chart.js").then(__webpack_require__.bind(__webpack_require__, /*! ./vendors/chart */ "./src/js/vendors/chart.js")).then(() => {
    //$(hbgCompletionChart).attr('hbg-chart-data')
    let data_chart = JSON.parse($(hbgCompletionChart).attr('hbg-chart-data'));
    new Chart(hbgCompletionChart, {
      // The type of chart we want to create
      type: 'roundedDoughnut',
      // The data for our dataset
      data: {
        labels: ['Completed', 'Not completed'],
        datasets: [{
          data: data_chart,
          backgroundColor: [_helpers__WEBPACK_IMPORTED_MODULE_0__.getCSSVariable(`${cssPrefix}primary`), _helpers__WEBPACK_IMPORTED_MODULE_0__.getCSSVariable(`${cssPrefix}light`)]
        }]
      },
      // Configuration options
      options: {
        plugins: {
          tooltip: {
            callbacks: {
              label: context => {
                return context.parsed + '%';
              }
            }
          }
        }
      }
    });
  }).catch(console.warn);
}